import { render } from "./FormInput.vue?vue&type=template&id=4b3d3290"
import script from "./FormInput.vue?vue&type=script&lang=js"
export * from "./FormInput.vue?vue&type=script&lang=js"
script.render = render

export default script